import { render, staticRenderFns } from "./DialogManageTaxCategories.vue?vue&type=template&id=727e5638"
import script from "./DialogManageTaxCategories.vue?vue&type=script&lang=js"
export * from "./DialogManageTaxCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports